import { render, staticRenderFns } from "./sic.vue?vue&type=template&id=7e903f24&lang=pug&"
import script from "./sic.vue?vue&type=script&lang=js&"
export * from "./sic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports